export const FETCH_USER_ISSUES_DETAILS = 'FETCH_USER_ISSUES_DETAILS';
export const FETCH_USER_ISSUES_DETAILS_SUCCESS = 'FETCH_USER_ISSUES_DETAILS_SUCCESS';
export const FETCH_USER_ISSUES_DETAILS_ERROR = 'FETCH_USER_ISSUES_DETAILS_ERROR';

export const FETCH_USER_ISSUES_CHAT = 'FETCH_USER_ISSUES_CHAT';
export const FETCH_USER_ISSUES_CHAT_SUCCESS = 'FETCH_USER_ISSUES_CHAT_SUCCESS';
export const FETCH_USER_ISSUES_CHAT_ERROR = 'FETCH_USER_ISSUES_CHAT_ERROR';